module.exports = __webpack_public_path__ + "img/logo1.280109dc.svg";